import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Login from "./pages/login/Login";
import Register from "./pages/register/Register";
import { Navigate } from "react-router-dom";
import Dashboard from "./pages/dashboard/Dashboard";
import Cookies from "js-cookie";
import AppProviders from "./context/appProvider";

export default function RedirectToHome() {
  const user = Cookies.get("session_user");

  return user ? (
    <Navigate to="/dashboard" replace />
  ) : (
    <Navigate to="/login" replace />
  );
}

let router = createBrowserRouter([
  {
    path: "/",
    Component: RedirectToHome,
  },
  {
    path: "/login",
    Component: Login,
  },
  {
    path: "/register",
    Component: Register,
  },
  {
    path: "/dashboard",
    Component: Dashboard,
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
      <AppProviders>
        <RouterProvider router={router} />
      </AppProviders>
  </React.StrictMode>
);

reportWebVitals();
